import React from 'react'

const COPY = {
  offline: {
    icon: 'wifi_off',
    title: 'Sem conexão',
    message: 'Verifique sua internet e tente novamente.',
  },
  timeout: {
    icon: 'hourglass_disabled',
    title: 'Tempo esgotado',
    message: 'O servidor demorou para responder. Tente novamente.',
  },
  network: {
    icon: 'cloud_off',
    title: 'Falha de conexão',
    message: 'Não foi possível falar com o servidor. Tente novamente.',
  },
  unauthorized: {
    icon: 'lock',
    title: 'Sessão inválida',
    message: 'Escaneie o QR Code novamente para continuar.',
  },
  server: {
    icon: 'error_outline',
    title: 'Algo deu errado',
    message: 'Ocorreu um erro ao carregar os dados. Tente novamente.',
  },
  malformed: {
    icon: 'qr_code_2',
    title: 'QR Code não reconhecido',
    message: 'O código escaneado não tem o formato esperado.',
  },
  invalid_company: {
    icon: 'domain_disabled',
    title: 'Empresa não encontrada',
    message: 'O ID da empresa neste QR Code não é válido.',
  },
  inactive_company: {
    icon: 'domain_disabled',
    title: 'Empresa inativa',
    message: 'Esta empresa está inativa no momento.',
  },
  invalid_token: {
    icon: 'key_off',
    title: 'Token inválido',
    message: 'O token deste QR Code é inválido ou expirou.',
  },
  token_mismatch: {
    icon: 'key_off',
    title: 'Token não corresponde',
    message: 'Este token não pertence à empresa informada no QR Code.',
  },
  invalid_user: {
    icon: 'person_off',
    title: 'Usuário não encontrado',
    message: 'Este usuário não pertence a esta empresa.',
  },
  inactive_user: {
    icon: 'person_off',
    title: 'Usuário inativo',
    message: 'Este usuário está inativo. Fale com o administrador da empresa.',
  },
  invalid_image: {
    icon: 'image_not_supported',
    title: 'Imagem inválida',
    message: 'Selecione uma imagem JPG ou PNG de até 8MB.',
  },
  no_qr_in_image: {
    icon: 'qr_code_2',
    title: 'QR Code não encontrado',
    message: 'Não foi possível identificar um QR Code nesta imagem. Tente uma foto mais nítida.',
  },
}

const ErrorState = ({ type = 'server', message, onRetry, compact = false }) => {
  const copy = COPY[type] || COPY.server

  return (
    <div className={`flex flex-col items-center justify-center text-center ${compact ? 'py-8 px-4' : 'py-16 px-6'}`}>
      <span
        className="material-icons text-gray-300 dark:text-gray-600 mb-3"
        style={{ fontSize: compact ? '32px' : '44px' }}
      >
        {copy.icon}
      </span>
      <p className="text-sm font-semibold text-gray-700 dark:text-gray-200">{copy.title}</p>
      <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 max-w-xs">{message || copy.message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-4 px-6 py-2 rounded-full text-sm font-semibold text-white transition active:scale-95"
          style={{ backgroundColor: '#25C6A4' }}
        >
          Tentar novamente
        </button>
      )}
    </div>
  )
}

export default ErrorState
